import { PureLightTheme } from "../../../styles/theme"
import { COLORS } from "../../../styles/variables"

export const BoxImgBadge = {
    marginRight: '38px',
    [PureLightTheme.breakpoints.down('sm')]: {
        display: 'none',
    },
}

export const TypTitle = {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflowWrap: 'anywhere', 

    margin: '13px 0px 14px 0px',
    [PureLightTheme.breakpoints.down('sm')]: {
        WebkitLineClamp: 2,
        fontSize: '18px',
        margin: '0px 0px 7px 0px',
    }
}

export const TypStatus = {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflowWrap: 'anywhere', 

    fontWeight: 400,
    marginBottom: '12px',
    [PureLightTheme.breakpoints.down('sm')]: {
        WebkitLineClamp: 2,
        fontSize: '15px',
        marginBottom: '6px',
    }
}

export const StackInfo = {
    [PureLightTheme.breakpoints.down('sm')]: {
        gap: 0.5,
    }
}

export const TypDescription = {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflowWrap: 'anywhere', 

    fontWeight: 300,
    color: COLORS.SMOKEY_GREY,

    [PureLightTheme.breakpoints.down('sm')]: {
        WebkitLineClamp: 2,
    }
}

export const TypCategories = {
    marginBottom: 1,

    [PureLightTheme.breakpoints.down("sm")]: {
        marginBottom: 0.5,
    }
}
